import AmazonAuCalculator from '@/tools/amazonAuCalculator.vue';
import { mountVueTool } from './shared/mountVueTool';

mountVueTool(AmazonAuCalculator, 'amazonAuCalculator');
